import { render, staticRenderFns } from "./platformCard.vue?vue&type=template&id=622d82bc&scoped=true&"
import script from "./platformCard.vue?vue&type=script&lang=ts&"
export * from "./platformCard.vue?vue&type=script&lang=ts&"
import style0 from "./platformCard.vue?vue&type=style&index=0&id=622d82bc&prod&lang=scss&scoped=true&"
import style1 from "./platformCard.vue?vue&type=style&index=1&id=622d82bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d82bc",
  null
  
)

export default component.exports